@if (timelineService.itemLoading$()) {
  <div class="flex h-screen items-center justify-center">
    <mat-spinner></mat-spinner>
  </div>
} @else if (itemGetResponse) {
  <mat-card-title class="theme-bg-1 p-2">
    <div class="font-semibold text-center w-full block truncate">
      <span class="blue-theme-text-1 truncate">ID:</span>
      {{ itemGetResponse?.id }}
    </div>
    <div class="text-center w-full theme-text-1">
      <span class="p-1">{{ itemGetResponse?.collectionInfo?.sourceName }}</span>
      @if (itemGetResponse?.collectionInfo?.associatedSources) {
        <span class="truncate text-sm p-1">{{
          itemGetResponse?.collectionInfo?.associatedSources?.join(', ')
        }}</span>
      }
      <span class="p-1">{{
        itemGetResponse?.eventTime | date: 'mediumDate' : 'UTC'
      }}</span>
    </div>
  </mat-card-title>

  @if (timelineSelectedItem?.type === taDirectTypeEnum.SCREENSHOT) {
    <div class="w-full">
      <ng-container
        *ngTemplateOutlet="
          dialogImgTemplate;
          context: { $implicit: { disableInteractions: false } }
        "
      ></ng-container>
    </div>
  }

  <div class="mt-1">
    <phoenix-expandable-panel
      #directCollectTextPanel
      ariaLabel="direct-collect-text"
      panelTitle="Direct Collect Text:"
      [collapseOnScroll]="true"
      [initOpened]="false"
      panelTitleClass="font-semibold"
      [extraActionConfig]="{
        show: shouldShowHighlight,
        icon: 'search',
        tooltip: 'Scroll to highlight',
        ariaLabel: 'scroll-to-highlight',
        onClick: scrollToFirstHighlight,
      }"
      (extraActionClicked)="scrollToFirstHighlight()"
    >
      <div class="flex justify-end">
        <phoenix-translation-switch
          [translationsEnabled]="hasTranslations()"
          [translateLabel]="translateLabel"
        >
        </phoenix-translation-switch>
      </div>
      @if (featureFlagsService.isOn('experiment_dcv_highlight')) {
        <div
          #highlightContainer
          [innerHTML]="selectedItemData"
          class="mt-2 p-2 mb-2 theme-bg-2 rounded-sm shadow-md leading-relaxed whitespace-pre-line"
        ></div>
      } @else {
        <div
          [innerHTML]="selectedItemData"
          class="mt-2 p-2 mb-2 theme-bg-2 rounded-sm shadow-md leading-relaxed whitespace-pre-line"
        ></div>
      }
    </phoenix-expandable-panel>
    @if (
      timelineSelectedItem?.type === taDirectTypeEnum.SCREENSHOT &&
      itemGetResponse?.sourceData?.id
    ) {
      <phoenix-timeline-screenshot-message
        [messageId]="itemGetResponse?.sourceData?.id ?? ''"
      >
      </phoenix-timeline-screenshot-message>
    }
  </div>
  <phoenix-json-record [record]="formattedMessage"></phoenix-json-record>
}

<ng-template #imgActionsTemplate>
  @if (timelineService.itemLoading$()) {
    <mat-spinner diameter="30"></mat-spinner>
  }
  <phoenix-img-actions
    [img]="itemGetResponse?.imgproxy_urls?.full ?? ''"
    [imgDownload]="itemGetResponse?.imgproxy_urls?.download ?? ''"
    [uploadButton]="false"
    [zoomImg]="false"
    [centerDivs]="true"
  ></phoenix-img-actions>
</ng-template>

<ng-template #dialogImgTemplate let-data>
  <phoenix-img-viewer
    [img]="itemGetResponse?.imgproxy_urls?.full ?? ''"
    [imgDownload]="itemGetResponse?.imgproxy_urls?.download ?? ''"
    [altText]="itemGetResponse?.id ?? ''"
    [zoomImg]="false"
    [movementArrows]="data.disableInteractions && !removeMovement"
    [imgActions]="!data.disableInteractions"
    [movementDisabled]="movementDisabled"
    [isInDialog]="data.disableInteractions"
    (clickImage)="!data.disableInteractions ? openFullSizeImg() : null"
    (imgMovement)="imgMovement.emit($event)"
  >
  </phoenix-img-viewer>
</ng-template>
